enum ChatUserMessageStatus {
  FAILED = "failed",
  SENDING = "sending",
  SENT = "sent",
}

export default ChatUserMessageStatus;
